

































import Vue from "vue";
import { MeService as meApi } from "@/common/api/services/MeService";
import Component from "vue-class-component";
import { MeGroupDTO } from "@/common/api";
@Component({
  name: "MyPageIndex",
})
export default class MyPageIndex extends Vue {
  groups: Array<MeGroupDTO> = [];
  mounted() {
    this.getList();
  }

  async getList() {
    const result = await meApi.meGroups({});

    this.groups = result.data.list;
  }

  getStatus(group: MeGroupDTO) {
    return group.hasApproved ? "follow" : "wait";
  }

  async follow(group: MeGroupDTO) {
    let result;
    try {
      result = await meApi.meFollow({
        groupId: group.id,
      });
    } catch (error) {
      result = error.body;
    }

    if (result.status === "error") {
      this.$notify({
        text: result.message,
      });
    } else {
      this.getList();
    }
  }
}
